import { FaCheck } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 GRUPO DE CHECKBOXES

    Faltaba: había grupo de radios pero no de checks. Trabaja con un
    array de valores; el onChange devuelve el array nuevo, no un evento.
*/

export const FieldCheckboxGroup = ({
    id, label, hint, error, options = [],
    value = [], onChange, direction = 'column',
    isRequired = false, isDisabled = false, span = 1,
}) => {

    const onToggle = (optValue) => {
        const NEXT = value.includes(optValue)
            ? value.filter((item) => item !== optValue)
            : [...value, optValue];
        onChange?.(NEXT);
    };

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell label={label} hint={hint} error={error}
            isRequired={isRequired} isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__radio_group`} data-direction={direction}>
                {
                    options.map((opt) => (

                        <label key={opt.value} className={`${BLOCK}__check`} htmlFor={`${id}_${opt.value}`}>

                            <input id={`${id}_${opt.value}`} type="checkbox"
                                className={`${BLOCK}__check_input`}
                                checked={value.includes(opt.value)}
                                onChange={() => onToggle(opt.value)}
                                disabled={isDisabled || opt.isDisabled} />

                            <span className={`${BLOCK}__check_box`} aria-hidden="true"><FaCheck /></span>

                            <span className={`${BLOCK}__check_text`}>{opt.label}</span>

                        </label>
                    ))
                }
            </div>

        </FieldShell>
    );
};
